export default `
  #graphql
  fragment OptimizedVariantFields on ProductInterface {
    id
    sku
    manufacturer
    uid
    name
    delivery_time
  }
`;
